export enum TaskStatus {
    Queued = 1283,
    Available = 1293,
    Completed = 1303,
    Cancelled = 1313,
    Paused = 2473,
}
